<template>
  <section class="pt-50 pb-50 bg-grey">
    <v-carousel
      class="home-carousel height-380px"
      cycle
      hide-delimiter-background
      show-arrows-on-hover
    >
      <v-carousel-item v-for="item in this.review" :key="item.index">
        <div class="row align-items-center justify-content-between">
          <div class="col-md-7 mt-50">
            <div class="about-content-left section-heading carouselDivHeading">
              <div class="carouselDiv">
                <p class="feedback">
                  {{ item.review }}
                </p>
              </div>
              <div class="single-feature mb-4 mt-5">
                <div class="icon-box-wrap d-flex align-items-center mb-2">
                  <!--<div class="mr-3 icon-box1">
                    <img
                      :src="item.image"
                      alt="client"
                      class="img-fluid rounded-circle"
                    />
                  </div>-->
                  <p class="mb-0">
                    <span class="fb-name">{{ item.name }}</span
                    ><br />
                    <span class="fb-profile">{{ item.place }}</span>
                  </p>
                  <br />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5 display">
            <div class="about-content-right">
              <img
                src="../assets/background/fb-sec.png"
                alt="about us"
                class="img-fluid fb-height"
              />
            </div>
          </div>
        </div>
      </v-carousel-item>
    </v-carousel>
  </section>
  <!--------------------------->
</template>
<script>
import { setLocale } from "../services/firebase";
import i18n from "../i18n";
export default {
  name: "Review",
  mounted() {
    setLocale();
  },
  /*data() {
    return {
      reviewData: [
        {
          review: i18n.t("customerFeedback.feedbackDivya"),
            // "I run a small textile business and every time i have new dress or saree pictures i used to send it on WhatsApp to my customers. My daughter explained and showed me how to use Sellwell and trust me it changed my perspective to run a business. \nNow instead of sending 100s of WhatsApp images, i share my product catalogue with my customers and i receive orders in a systematic way, moreover this has given me a lot of confidence to run my business in such a competitive world.",
          name: "Divya Bakshi",
          place: "Blackbird Boutique",
          image: "https://appco-vue.themetags.com/img/client-2.jpg",
        },
        {
          review: i18n.t("customerFeedback.feedbackAdan"),
              // "He estado usando la herramienta Sellwell estos últimos meses, y he experimentado la facilidad de enviar mi catálogo de productos a los clientes y recibir los pedidos sin ninguna confusión o desafío técnico. \n Es una herramienta especialmente útil para alguien que dirige un pequeño negocio desde su casa, y que no quiere derrochar miles de dólares en la creación de sitios web o aplicaciones.",
          name: "Adan Morales",
          place: "Sanchez Enterprises",
          image: "https://appco-vue.themetags.com/img/client-1.jpg",
        },
        {
          review: i18n.t("customerFeedback.feedbackSantiago"),
            //  "A Sellwell tem me ajudado a desenvolver o meu negócio em um período realmente curto. Noto diariamente um aumento na quantidade de pedidos que recebo.",
          name: "Santiago Lopez",
          place: "UCC Groupe",
          image: "https://appco-vue.themetags.com/img/client-4.jpg",
        },

        {
          review: i18n.t("customerFeedback.feedbackDevanshi"),
          //  `I run a small confectionery business based out of Ahmedabad, everytime when clients ask for pictures and flavour options for cakes, i used to send it in an unorganised way on whatsapp or used to put it up on WhatsApp stories. A friend of mine told me about Sellwell, i tried it for some time and experienced the growth in my business. Also, it allows customers to send the orders directly on WhatsApp to avoid unnecessary confusion.`,
          name: " Devanshi Patel",
          place: "Bake n Flake",
        },
        {
          review: i18n.t("customerFeedback.feedbackJayantilal"),
          //  `It’s been a while since I have been using Sellwell for my business orders, I have customers across Indore, Madhya Pradesh and since our business works more on trust it’s very important to deliver orders in the correct quantity and promised timeline. Sellwell has helped me grow my business without paying anything. I can create upto 5 product catalogs and keep adding items into each category which eases customers' buying decisions.`,
          name: "Jayantilal Sharma",
          place: "J.S Textiles",
        },
        {
          review: i18n.t("customerFeedback.feedbackRajan"),
          //  `Sellwell is the new way for doing business. A great way to create a digital catalog wherein it allows users to create upto 5 different product catalogs at free of cost.\nA great UI to stay connected with customers and share regular product / service updates.`,
          name: "Rajan Shukla",
          place: "Organic Magic",
        },
      ],
    };
  },*/
  computed:{
    review:function(){
     return [
        {
          review: i18n.t("customerFeedback.feedbackDivya"),
            // "I run a small textile business and every time i have new dress or saree pictures i used to send it on WhatsApp to my customers. My daughter explained and showed me how to use Sellwell and trust me it changed my perspective to run a business. \nNow instead of sending 100s of WhatsApp images, i share my product catalogue with my customers and i receive orders in a systematic way, moreover this has given me a lot of confidence to run my business in such a competitive world.",
          name: "Divya Bakshi",
          place: "Blackbird Boutique",
          image: "https://appco-vue.themetags.com/img/client-2.jpg",
        },
        {
          review: i18n.t("customerFeedback.feedbackAdan"),
              // "He estado usando la herramienta Sellwell estos últimos meses, y he experimentado la facilidad de enviar mi catálogo de productos a los clientes y recibir los pedidos sin ninguna confusión o desafío técnico. \n Es una herramienta especialmente útil para alguien que dirige un pequeño negocio desde su casa, y que no quiere derrochar miles de dólares en la creación de sitios web o aplicaciones.",
          name: "Adan Morales",
          place: "Sanchez Enterprises",
          image: "https://appco-vue.themetags.com/img/client-1.jpg",
        },
        {
          review: i18n.t("customerFeedback.feedbackSantiago"),
            //  "A Sellwell tem me ajudado a desenvolver o meu negócio em um período realmente curto. Noto diariamente um aumento na quantidade de pedidos que recebo.",
          name: "Santiago Lopez",
          place: "UCC Groupe",
          image: "https://appco-vue.themetags.com/img/client-4.jpg",
        },

        {
          review: i18n.t("customerFeedback.feedbackDevanshi"),
          //  `I run a small confectionery business based out of Ahmedabad, everytime when clients ask for pictures and flavour options for cakes, i used to send it in an unorganised way on whatsapp or used to put it up on WhatsApp stories. A friend of mine told me about Sellwell, i tried it for some time and experienced the growth in my business. Also, it allows customers to send the orders directly on WhatsApp to avoid unnecessary confusion.`,
          name: " Devanshi Patel",
          place: "Bake n Flake",
        },
        {
          review: i18n.t("customerFeedback.feedbackJayantilal"),
          //  `It’s been a while since I have been using Sellwell for my business orders, I have customers across Indore, Madhya Pradesh and since our business works more on trust it’s very important to deliver orders in the correct quantity and promised timeline. Sellwell has helped me grow my business without paying anything. I can create upto 5 product catalogs and keep adding items into each category which eases customers' buying decisions.`,
          name: "Jayantilal Sharma",
          place: "J.S Textiles",
        },
        {
          review: i18n.t("customerFeedback.feedbackRajan"),
          //  `Sellwell is the new way for doing business. A great way to create a digital catalog wherein it allows users to create upto 5 different product catalogs at free of cost.\nA great UI to stay connected with customers and share regular product / service updates.`,
          name: "Rajan Shukla",
          place: "Organic Magic",
        },
      ] 
    }
  }
};
</script>
<style lang="scss">
.home-carousel {
  .v-carousel__controls {
    button {
      outline: none;
    }
    .v-item--active i {
      color: #532fc7;
      opacity: 1;
    }
  }
}
.home-carousel {
  .v-carousel__controls {
    button {
      outline: none;
    }
    .v-btn--icon {
      color: grey;
      opacity: 1;
    }
  }
}
.carouselDiv {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #0000001a;
  opacity: 1;
  border-radius: 10px;
}
.icon-box1 {
  width: 80px;
}

@media (min-width: 320px) and (max-width: 960px)  {
  .display {
    display: none;
  }
  .carouselDivHeading {
    margin: auto;
    width: 70%;
  }
  .fb-height {
    height: 380px;
  }
  .home-carousel .v-carousel__item {
    height: 380px;
  }
  .mt-50 {
    margin-top: 50px;
  }
}
@media (min-width: 960px) {
  .display {
    display: block;
  }
  .carouselDivHeading {
    margin: auto;
    width: 50%;
  }
  .home-carousel .v-carousel__item {
    height: 500px;
  }
  .fb-height {
    height: 500px;
  }
}
</style>
